import Users from "../../pages/Users";

/**
 * Settings › Access & Security › User Accounts.
 * Renders the existing Users management UI in embedded mode (no page header).
 * The standalone /users route remains functional for backward compatibility.
 */
export function UserAccountsSettings() {
  return <Users embedded />;
}

export default UserAccountsSettings;
